import { forwardRef, TextareaHTMLAttributes, useCallback, useState, type ChangeEvent } from 'react';

import { TextArea } from '@hh.ru/magritte-ui-textarea/TextArea';
import { UncontrolledTextAreaProps } from '@hh.ru/magritte-ui-textarea/types';

export const UncontrolledTextArea = forwardRef<
    HTMLTextAreaElement,
    UncontrolledTextAreaProps & Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, keyof UncontrolledTextAreaProps>
>(({ value = '', onChange, ...restProps }, ref) => {
    const [defaultValue, setDefaultValue] = useState(value);
    const changeHandler = useCallback(
        (event: ChangeEvent<HTMLTextAreaElement>) => {
            setDefaultValue(event.target.value);
            onChange?.(event);
        },
        [onChange]
    );

    return <TextArea {...restProps} value={defaultValue} onChange={changeHandler} ref={ref} />;
});

UncontrolledTextArea.displayName = 'UncontrolledTextArea';
